import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ContratoState } from './contrato.state';
import { Contrato } from '../models/contrato.interface';

export const selectContratoState = createFeatureSelector<ContratoState>('contrato');

export const selectAllContratos = createSelector(
  selectContratoState,
  (state: ContratoState) => state.contratos
);

export const selectSelectedContrato = createSelector(
  selectContratoState,
  (state: ContratoState) => state.selectedContrato
);

export const selectContratoLoading = createSelector(
  selectContratoState,
  (state: ContratoState) => state.loading
);

export const selectContratoError = createSelector(
  selectContratoState,
  (state: ContratoState) => state.error
);

export const selectContratoCreating = createSelector(
  selectContratoState,
  (state: ContratoState) => state.creating
);

export const selectContratoUpdating = createSelector(
  selectContratoState,
  (state: ContratoState) => state.updating
);

export const selectContratoDeleting = createSelector(
  selectContratoState,
  (state: ContratoState) => state.deleting
);

export const selectContratoSearchResults = createSelector(
  selectContratoState,
  (state: ContratoState) => state.searchResults
);

export const selectContratoSearchQuery = createSelector(
  selectContratoState,
  (state: ContratoState) => state.searchQuery
);

export const selectContratoById = createSelector(
  selectAllContratos,
  (contratos: Contrato[], id: number) => contratos.find(c => c.numeroContratoId === id)
);

export const selectContratosCount = createSelector(
  selectAllContratos,
  (contratos: Contrato[]) => contratos.length
);
